import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from '@bingads-webui-react/wizard';
import { ErrorBar } from '@bingads-webui-fluent-component/wizard-ui-library';

import { DisplayPlusWizard } from './wizard';
import { EditFooter } from '../footers';

export const DisplayPlusEditWizard = ({
  wizardType, flowType, routeToNavigateToWhenDone, initialWizardData, perfMarker,
}) => (
  <DisplayPlusWizard
    wizardType={wizardType}
    flowType={flowType}
    routeToNavigateToWhenDone={routeToNavigateToWhenDone}
    initialWizardData={initialWizardData}
    perfMarker={perfMarker}
  >
    <Layout type="ErrorBar" component={ErrorBar} />
    <Layout
      type="Footer"
      component={EditFooter}
      saveAndExitButtonText={_TL_('Save')}
      cancelButtonText={_TL_('Cancel')}
    />
  </DisplayPlusWizard>
);

DisplayPlusEditWizard.propTypes = {
  siteMap: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    save: PropTypes.func.isRequired,
  }).isRequired,
  perfMarker: PropTypes.shape({
    createChild: PropTypes.func.isRequired,
  }).isRequired,
  wizardType: PropTypes.string.isRequired,
  flowType: PropTypes.string.isRequired,
  routeToNavigateToWhenDone: PropTypes.func.isRequired,
  initialWizardData: PropTypes.shape({}).isRequired,
};
